import {
  TerritoryItem,
  TerritoryItemTypeEnum,
} from "@shared/apis/sidekick/generated";

export const TERRITORY_ALIAS_SEPARATOR = "|";

export const parseTerritoryName = (
  raw: string,
): { baseName: string; aliases: string[] } => {
  const parts = raw.split(TERRITORY_ALIAS_SEPARATOR).map((p) => p.trim());
  return { baseName: parts[0], aliases: parts.slice(1).filter(Boolean) };
};

export const formatTerritoryDisplayName = (
  territory: TerritoryItem,
): string => {
  const { baseName, aliases } = parseTerritoryName(territory.name);
  return aliases.length > 0 ? `${baseName} (${aliases.join(", ")})` : baseName;
};

export const formatTerritoryOptionLabel = (
  territory: TerritoryItem,
): string => {
  const { baseName, aliases } = parseTerritoryName(territory.name);
  const nameWithAliases =
    aliases.length > 0 ? `${baseName} (${aliases.join(", ")})` : baseName;
  if (territory.city) {
    return [nameWithAliases, territory.city, territory.state]
      .filter(Boolean)
      .join(", ");
  }
  return [nameWithAliases, territory.state].filter(Boolean).join(", ");
};

export const getTerritoryTypeLabel = (type: TerritoryItemTypeEnum): string => {
  switch (type) {
    case TerritoryItemTypeEnum.Neighborhood:
      return "Neighborhood";
    case TerritoryItemTypeEnum.City:
      return "City";
    case TerritoryItemTypeEnum.County:
      return "County";
    case TerritoryItemTypeEnum.District:
      return "District";
    case TerritoryItemTypeEnum.SubDistrict:
      return "Sub-District";
    case TerritoryItemTypeEnum.SchoolDistrict:
      return "School District";
    default:
      return "Other";
  }
};
